import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Captures UTM parameters + referrer on first visit and stores in sessionStorage.
 * Any page can read getAttribution() to get the attribution data for inquiry forms.
 */
export function useAttribution() {
  const location = useLocation();

  useEffect(() => {
    // First-touch attribution: the sessionStorage flag makes later route changes a no-op
    if (sessionStorage.getItem('attribution_captured')) return;

    const params = new URLSearchParams(location.search);
    const attribution = {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || '',
      referrer: document.referrer || '',
      landing_page: location.pathname + location.search,
    };

    // Only store if there's at least one non-empty value
    const hasData = Object.values(attribution).some(v => v);
    if (hasData) {
      sessionStorage.setItem('attribution', JSON.stringify(attribution));
    }
    sessionStorage.setItem('attribution_captured', 'true');
  }, [location.pathname, location.search]);
}

export function getAttribution() {
  try {
    const raw = sessionStorage.getItem('attribution');
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
